export const PAY_PIPE_API_URL = process.env.REACT_APP_PAYPIPE_API_URL!;

export const LOCAL_STORE_AUTH_DATA_KEY = "PAYPIPE";
